import Service from "../../../Services/index";

const Promotion = {
    namespaced: true,
    state: {
        promotionList: [],
        promotion_all: [],
        form: {
            name: "",
            description: "",
            status_id: 1,
            start_date: "",
            end_date: "",
            condition: 1,
            quantity: "",
            unit_type: 1,
            discount: "",
            discount_status_id: 1,
            promotion_products: [],
            checked: [],
            onSave: false,
            sale_id: null,
        },
        condition: [],
        products: [],
        search: {
            name: "",
            date: [],
            status: "",
        },
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
        product_dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        }
    },
    mutations: {
        GET_PROMOTION: (state, res) => {
            state.promotionList = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.from,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            };
        },
        GET_PROMOTION_ALL: (state, res) => {
            state.promotion_all = res;
        },
        GET_PROMOTION_BY_ID: (state, res) => {
            state.form = res;
        },
        GET_CONDITION_PROMOTION: (state, data) => {
            state.condition = data;
        },
        CLEAR_DATA: state => {
            state.form = {
                name: "",
                description: "",
                status_id: 1,
                start_date: "",
                end_date: "",
                condition: 1,
                quantity: "",
                unit_type: 1,
                discount: "",
                discount_status_id: 1,
                promotion_products: [],
                checked: [],
                onSave: false,
                sale_id: null,
            }
        },
        GET_PRODUCT: (state, res) => {
            state.products = res.data;
            state.product_dataPaginate = {
                current_page: res.current_page,
                from: res.from,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            };
        },
        CLEAR_SEARCH: (state) => {
            state.search = {
                name: "",
                date: [],
                status: "",
            }
        }
    },
    actions: {
        setPromotion({commit}, page = 1) {
            return Service.Promotion.getPromotion(page).then(res => {
                commit("GET_PROMOTION", res);
            });
        },
        setPromotionAll({commit}, data) {
            return Service.Promotion.getPromotionAll(data).then(res => {
                commit("GET_PROMOTION_ALL", res);
                return res;
            });
        },
        PromotionAll({commit}, data) {
            return Service.Promotion.PromotionAll()
        },
        showPromotion({commit}, id) {
            return Service.Promotion.showPromotion(id).then(res => {
                commit("GET_PROMOTION_BY_ID", res);
            })
        },
        savePromotion({commit}, {id, data}) {
            //console.log(data);
            if (!id) {
                return Service.Promotion.createPromotion(data).then(res => {
                    //console.log(res);
                });
            } else {
                return Service.Promotion.updatePromotion(id, data).then(res => {
                    //console.log(res);
                });
            }
        },
        deletePromotion({commit}, id) {
            return Service.Promotion.deletePromotion(id);
        },
        getConditionPro({commit}) {
            return Service.Promotion.getConditionPromotion().then(data => {
                commit("GET_CONDITION_PROMOTION", data);
            })
        },
        clearData({commit}) {
            commit("CLEAR_DATA");
        },
        addDetails({commit}, data) {
            commit("ADD_DETAILS", data);
        },
        removeDetails({commit}, index) {
            commit("REMOVE_DETAILS", index);
        },
        selectAllProducts({commit}, data) {
            return Service.Promotion.selectAllProducts(data);
        },
        getProduct({commit}, page = 1) {
            return Service.products.getProduct(page).then(res => {
                commit("GET_PRODUCT", res);
            })
        },
        searchPromotion({commit}, data) {
            return Service.Promotion.searchPromotion(data).then(res => {
                commit("GET_PROMOTION", res)
            })
        },
        clearSearch({commit}) {
            commit("CLEAR_SEARCH");
        },
    }
};

export default Promotion;
